/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useEffect, useState } from 'react';
import queryString from 'query-string';
import Loading from 'src/components/Loading/index.js';
import withCotizacion from 'src/HOC/withCotizacion';
import useCotizacion from 'src/hooks/useCotizacion';
import useCustomRouter from 'src/hooks/useCustomRouter';
import useCustomToast from 'src/hooks/useCustomToast';
import usePageValidation from 'src/hooks/usePageValidation';
import { guardarLead, guardarLeadPoliza, POST } from 'src/services';
import { urlBeforeSavePoliza, urlIngresarPoliza, urlVerificarPoliza } from 'src/services/urls';
import useQueryString from 'src/hooks/useQueryString';

const tagPage = 'ingresarPoliza';

const Index = () => {
  const { cotizacion, idCotizacion } = useCotizacion();
  const history = useCustomRouter();

  const { execEvent, isLoadingCallbacks } = usePageValidation(tagPage);
  const { addErrorToast } = useCustomToast();
  const [pageProps, setPageProps] = useState({});
  const qParams = useQueryString();

  const init = useCallback(async () => {

    if (qParams?.accepted === 'False' && qParams?.uniqueId) {
      addErrorToast('Para finalizar la compra, debe ACEPTAR la firma en el documento', { autoDismiss: false });
      return history.push(`/firmarCertificado/${idCotizacion}`);
    }

    execEvent('initCallback', { pageProps, setPageProps }, async () => {

      if (cotizacion.producto.tieneFirma === '0') {
        await POST(urlBeforeSavePoliza(idCotizacion));
      }
      const resVerificar = await POST(urlVerificarPoliza, { idCotizacion });
      guardarLead(idCotizacion, `INGRESAR_POLIZA__VERIFICANDO_POLIZA_INGRESADA`);

      execEvent('afterVerificarPoliza', { pageProps, setPageProps, resVerificar }, async () => {
        if (resVerificar.transaccion && !resVerificar.error) {
          const { ingresada, idPoliza } = resVerificar.data;
          if (ingresada && idPoliza) {
            guardarLeadPoliza(idPoliza, 'INGRESAR_POLIZA__INGRESO_POLIZA');
            execEvent('polizaIngresada', { pageProps, setPageProps, idPoliza }, async () => {
              guardarLead(
                idCotizacion,
                `INGRESAR_POLIZA__POLIZA_YA_INGRESADA_${ingresada}_ID:_${idPoliza}`,
              );
              redireccionar(idPoliza);
            });
          } else {
            const resPoliza = await POST(urlIngresarPoliza(idCotizacion));
            execEvent('ingresarPoliza', { pageProps, setPageProps, resPoliza }, async () => {
              guardarLead(idCotizacion, `INGRESAR_POLIZA__NUEVA_POLIZA_ID:_${resPoliza.idPoliza}`);
              if (resPoliza.transaccion && resPoliza.idPoliza) {
                redireccionar(resPoliza.idPoliza);
              }
            });
          }
        } else {
          addErrorToast('HA OCURRIDO UN PROBLEMA EN EL PROCESO DE VALIDACION', {
            autoDismiss: false,
          });
        }
      });
    });
  }, [isLoadingCallbacks]);

  const redireccionar = (idPoliza) => {
    execEvent('redireccionarAfterSave', { pageProps, setPageProps, idPoliza }, async () => {
      history.push(`/newFinCompra/${idCotizacion}?&${queryString.stringify(qParams)}`);
    });
  };

  useEffect(() => {
    guardarLead(idCotizacion, 'INGRESAR_POLIZA__INGRESO');
  }, []);

  useEffect(() => {
    if (isLoadingCallbacks) return;
    //Verifica si se realizo la firma para poder ingresar la poliza
    init();

    return () => {
      execEvent('outCallback');
    };
  }, [isLoadingCallbacks]);

  return <Loading principal="Validando Poliza" secundario="Espere por favor" />;
};

const IngresarPoliza = withCotizacion(Index);
export default IngresarPoliza;
